import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import VideoViewer from './video-viewer';
import { VIDEO_TYPE_LEGACY, VIDEO_TYPE } from './types';
import { sizeClassName } from './classNameStrategies';
import styles from './styles/default-video-styles.scss';
const DEFAULTS = {
    config: {
        size: 'content',
        alignment: 'center'
    }
};
const MAX_WAIT_TIME = 5000;
var _React_Component;
class VideoComponent extends (_React_Component = React.Component) {
    componentDidMount() {
        this.handlePlayerFocus();
    }
    componentDidUpdate() {
        this.handlePlayerFocus();
    }
    handlePlayerFocus() {
        const domNode = this.rootRef.current;
        if (!domNode) {
            return false;
        }
        // TODO: get rid of this ASAP!
        // Currently, there's no other means to access the player inner iframe
        const iframe = domNode.querySelector('iframe');
        return !this.state.isPlayable && this.playerRef.current && iframe && (iframe.tabIndex = -1);
    }
    render() {
        const { className, onClick, t } = this.props;
        const { isPlayable } = this.state;
        const containerClassNames = classNames(this.styles.video_container, className || '');
        /* eslint-disable jsx-a11y/no-static-element-interactions */ return /*#__PURE__*/ React.createElement("div", {
            onClick: onClick,
            className: containerClassNames,
            onKeyDown: (e)=>this.onKeyDown(e, onClick),
            ref: this.rootRef
        }, !isPlayable && this.renderOverlay(t), this.renderPlayer());
    /* eslint-enable jsx-a11y/no-static-element-interactions */ }
    constructor(props){
        super(props);
        _define_property(this, "rootRef", /*#__PURE__*/ React.createRef());
        _define_property(this, "playerRef", /*#__PURE__*/ React.createRef());
        _define_property(this, "styles", void 0);
        _define_property(this, "handlePlay", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            this.setState({
                isLoading: true
            });
            setTimeout(()=>this.handleReady(), MAX_WAIT_TIME);
        });
        _define_property(this, "handleVideoStart", (player)=>{
            if (this.playerRef.current !== player) {
                this.setState({
                    isLoading: false,
                    isLoaded: false
                });
            }
        });
        _define_property(this, "handleStart", ()=>{}) // tslint:disable-line
        ;
        _define_property(this, "handleReady", ()=>{
            if (!this.state.isLoaded) {
                this.setState({
                    isLoaded: true
                });
            }
        });
        _define_property(this, "renderOverlay", (t)=>{
            return /*#__PURE__*/ React.createElement("div", {
                className: classNames(this.styles.video_overlay)
            });
        });
        _define_property(this, "renderPlayer", ()=>{
            const { componentData } = this.props;
            return /*#__PURE__*/ React.createElement(VideoViewer, {
                componentData: componentData,
                onReady: this.handleReady,
                onStart: this.handleStart
            });
        });
        _define_property(this, "onKeyDown", (e, handler)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                handler();
            }
        });
        const isPlayable = !props.blockProps || props.blockProps.readOnly === true;
        this.state = {
            isLoading: false,
            isLoaded: false,
            isPlayable
        };
        this.styles = mergeStyles({
            styles: styles,
            theme: this.props.theme || {}
        });
    }
}
_define_property(VideoComponent, "sizeClassName", (componentData, theme, internalStyles, isMobile)=>sizeClassName(componentData, theme, internalStyles, isMobile));
_define_property(VideoComponent, "propTypes", {
    componentData: PropTypes.object.isRequired,
    componentState: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    blockProps: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    theme: PropTypes.object.isRequired,
    t: PropTypes.func
});
_define_property(VideoComponent, "type", {
    VIDEO_TYPE_LEGACY,
    VIDEO_TYPE
});
export { VideoComponent as Component, DEFAULTS };

//# sourceMappingURL=video-component.js.map